import { render, staticRenderFns } from "./PartnerTransferCheck.vue?vue&type=template&id=5f00d3bc&scoped=true&"
import script from "./PartnerTransferCheck.vue?vue&type=script&lang=js&"
export * from "./PartnerTransferCheck.vue?vue&type=script&lang=js&"
import style0 from "./PartnerTransferCheck.vue?vue&type=style&index=0&id=5f00d3bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00d3bc",
  null
  
)

export default component.exports